import type { ListSocialPostsArg } from './types.generated';
import { hookExports } from './smm-api';
import { selectSocialPosts, selectSocialPostsNextCursor } from './list-adapter';
import type { SocialPost } from './list-adapter';

/**
 * Lists social posts, optionally filtered by status, with `data` already
 * unwrapped to a posts array by {@link selectSocialPosts}.
 *
 * Prefer this over the raw `useListSocialPosts` hook: it keeps consumers
 * independent of the response envelope (see SKY-4767).
 *
 * @param arg - Optional `status` filter.
 * @param options - Regular RTK Query options (`skip`, `pollingInterval`, ...).
 * @returns The query result with `data` as the posts and `nextCursor` as the
 * cursor of the next page (`null` until the endpoint paginates).
 */
export const useSocialPosts = (
  arg: ListSocialPostsArg = {},
  options?: Omit<Parameters<typeof hookExports.useListSocialPosts>[1], 'selectFromResult'>,
) => {
  const result = hookExports.useListSocialPosts(arg, options);
  const posts: readonly SocialPost[] = selectSocialPosts(result.data);
  const nextCursor = selectSocialPostsNextCursor(result.data);

  return { ...result, data: posts, nextCursor };
};
